export default "__VITE_ASSET__38528004__"